import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

function CreateStudentModal({ regModalData, onClose, refreshOnSubmitSuccess }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [sections, setSections] = useState([]);

  // Fetch sections from API
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await get(
          `ClassSection/GetAllSectionByCenterClassIdAndCenterId?centerClassId=${regModalData.classId}&centerId=${regModalData.centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (Array.isArray(response)) {
          setSections(response);
        } else {
          console.error("Unexpected API response format:", response);
          setSections([]);
        }
      } catch (error) {
        console.error("Error fetching sections:", error);
        setSections([]);
      }
    };

    if (regModalData) {
      fetchSections();
    }
  }, [regModalData]);

  if (!regModalData) {
    return null;
  }

  const saveData = async (formData) => {
    setIsLoading(true);
    try {
      // Fetch registration data
      const token = localStorage.getItem("token");
      const registrationResponse = await get(
        `InspRegistration/GetRegistrationByStudentFirstRegistrationId?studentFirstRegistrationId=${regModalData.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (
        !registrationResponse.isSuccess ||
        !registrationResponse.registration
      ) {
        throw new Error(
          registrationResponse.message || "Failed to fetch registration data"
        );
      }

      const registrationData = registrationResponse.registration;

      // Prepare payload for Student/AddUpdateStudentAsync
      const studentPayload = {
        ...registrationData,
        id: 0,
        classSectionId: parseInt(formData.section), // Add selected section ID as classSectionId
        createdBy: localStorage.getItem("userId"),
        organizationId: localStorage.getItem("organizationId"),
        formId: 21,
        notificationEventTypeIds: "1",
      };
      console.log(studentPayload);
      // Call Student/AddUpdateStudentAsync API
      const studentResponse = await post(
        `Student/AddUpdateStudentAsync`,
        studentPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!studentResponse.isSuccess) {
        throw new Error(studentResponse.message || "Failed to save student");
      }

      toast.success("Student created successfully!");
      await refreshOnSubmitSuccess(); // Refresh parent component data
      onClose(); // Close modal on success
    } catch (error) {
      console.error("Error processing student creation:", error);
      toast.error(`Failed to save student: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Create Student</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(saveData)}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="fw-bold">Student Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={regModalData.studentFullName}
                      disabled
                      readonly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="fw-bold">Class:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={regModalData.className}
                      disabled
                      readonly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="fw-bold">Admission Challan #:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={regModalData.regChallanNo}
                      disabled
                      readonly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="fw-bold">Admission Date:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={new Date().toISOString().split("T")[0]}
                      disabled
                      readonly
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="fw-bold">
                      Section <span className="text-danger fs-9">*</span>
                    </label>
                    <select
                      {...register("section", {
                        required: "This field is required.",
                      })}
                      className="form-select"
                    >
                      <option value="">Select a section</option>
                      {sections.map((section) => (
                        <option key={section.id} value={section.id}>
                          {section.name}
                        </option>
                      ))}
                    </select>
                    {errors.section && (
                      <small className="text-danger">
                        {errors.section.message}
                      </small>
                    )}
                  </div>

                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={onClose}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <span
                          className="spinner-border spinner-custom-size me-1"
                          aria-hidden="true"
                        ></span>
                      ) : null}
                      <span role="status">Save</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default CreateStudentModal;
